import styled from 'styled-components';
import * as palette from 'config';

export const ListContainer = styled.div`
    flex: 1; /* We know the parent is a flex-box, but this is a really ugly solution, it should be independent from the parent */
    display: flex;
    flex-direction: column;
    align-self: flex-start;
`;

export const TableHeightRef = styled.div`
    position: absolute;
    height: calc(100vh - ${palette.HEADER_SIZE} - 800px);
`;
